import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  align-items: center;
`;

export const FormatPlace = styled.div`
  margin-right: 1rem;
  select {
    padding: 5px 4px;
  }
`;
